import Seo from "@/components/Seo";
import { LineMask, FadeUp } from "@/components/Reveal";

const Impressum = () => (
  <>
    <Seo
      title="Impressum | DIMEDIAL Studio Herford"
      description="Impressum von DIMEDIAL Studio, Mindener Str. 52, 32049 Herford."
      path="/impressum"
    />
    <div className="shell pt-44 pb-28 md:pb-40" data-testid="impressum-page">
      <h1 className="font-display font-semibold uppercase tracking-tight leading-[0.95] text-5xl md:text-7xl lg:text-8xl text-paper mb-16 md:mb-24">
        <LineMask>Impressum<span className="text-gold">.</span></LineMask>
      </h1>

      <div className="max-w-2xl space-y-14">
        <FadeUp>
          <section aria-label="Angaben gemäß § 5 TMG">
            <h2 className="label-text mb-5">Angaben gemäß § 5 TMG</h2>
            <p className="text-lg text-paper/90 leading-relaxed">
              Dimedial.de<br />
              Mindener Str. 52<br />
              32049 Herford
            </p>
          </section>
        </FadeUp>

        <FadeUp delay={0.05}>
          <section aria-label="Kontakt">
            <h2 className="label-text mb-5">Kontakt</h2>
            <p className="text-lg text-paper/90 leading-relaxed">
              Telefon: <a href="tel:+4952211412070" data-testid="impressum-phone-1" className="hover:text-gold transition-colors duration-500">05221-1412070</a><br />
              E-Mail: <a href="mailto:info@dimedial.de" data-testid="impressum-email" className="hover:text-gold transition-colors duration-500">info@dimedial.de</a>
            </p>
          </section>
        </FadeUp>

        <FadeUp delay={0.1}>
          <section aria-label="Geschäftsführung">
            <h2 className="label-text mb-5">Geschäftsführer</h2>
            <p className="text-lg text-paper/90 leading-relaxed">
              Thomas Dickenbrok<br />
              <a href="mailto:thomas@dimedial.de" data-testid="impressum-email-gf" className="hover:text-gold transition-colors duration-500">thomas@dimedial.de</a>
            </p>
          </section>
        </FadeUp>

        <FadeUp delay={0.15}>
          <section aria-label="Umsatzsteuer-ID">
            <h2 className="label-text mb-5">Umsatzsteuer</h2>
            <p className="text-lg text-paper/90 leading-relaxed">
              Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:<br />
              DE323567202
            </p>
          </section>
        </FadeUp>
      </div>
    </div>
  </>
);

export default Impressum;
